import confetti from 'canvas-confetti';

const confettiColors = ['#f5bf00', '#e88800', '#e10337', '#ba0263', '#873f95', '#3c70b3', '#04ac80', '#88c15f'];

const allProjectColors = [
    // audio2edit
    // '#004d40',
    // '#00695c',
    // '#00796b',
    // '#00897b',
    // '#009688',
    // '#26a69a',
    // '#4db6ac',
    // '#80cbc4',
    // compress2go
    '#d50000',
    '#d32f2f',
    '#e53935',
    '#f44336',
    '#ef5350',
    '#e57373',
    '#ef9a9a',
    '#ffcdd2',
    // ebook2edit
    // '#ffab00',
    // '#ffa000',
    // '#ffb300',
    // '#ffc107',
    // '#ffca28',
    // '#ffd54f',
    // '#ffe082',
    // '#ffecb3',
    // img2go
    // '#0d47a1',
    // '#1565c0',
    // '#1976d2',
    // '#1e88e5',
    // '#2196f3',
    // '#42a5f5',
    // '#64b5f6',
    // '#90caf9',
    // ocr2edit
    // '#37474f',
    // '#455a64',
    // '#546e7a',
    // '#607d8b',
    // '#78909c',
    // '#90a4ae',
    // '#b0bec5',
    // '#cfd8dc',
    // online-convert
    // '#1b5e20',
    // '#2e7d32',
    // '#388e3c',
    // '#43a047',
    // '#4caf50',
    // '#66bb6a',
    // '#81c784',
    // '#a5d6a7',
    // pdf2go
    // '#f5bf00',
    // '#e88800',
    // '#e10337',
    // '#ba0263',
    // '#873f95',
    // '#3c70b3',
    // '#04ac80',
    // '#88c15f',
    // video2edit
    '#4a148c',
    '#6a1b9a',
    '#7b1fa2',
    '#8e24aa',
    '#9c27b0',
    '#ab47bc',
    '#ba68c8',
    '#ce93d8',
];

/**
 *
 * @param {String} element
 */
function launchConfetti(element) {
    const confettiLeftOffset = document.getElementById(element).getBoundingClientRect().x / window.innerWidth;

    const duration = 750;
    const end = Date.now() + duration;
    const defaults = {
        decay: 0.93,
        scalar: 0.6,
        disableForReducedMotion: true,
        colors: confettiColors,
        zIndex: 10000,
        particleCount: 8,
    };

    (function launch() {
        // launch a few confetti from the left edge
        confetti(
            Object.assign({}, defaults, {
                angle: 65,
                spread: 45,
                origin: { x: confettiLeftOffset, y: 1 },
            })
        );
        // and launch a few from the right edge
        confetti(
            Object.assign({}, defaults, {
                angle: 115,
                spread: 45,
                origin: { x: 1, y: 1 },
            })
        );

        // keep going until we are out of time
        if (Date.now() < end) {
            requestAnimationFrame(launch);
        }
    })();
}

function launchConfettiFireworks() {
    const duration = 2000;
    const animationEnd = Date.now() + duration;
    const defaults = {
        startVelocity: 10,
        spread: 360,
        ticks: 60,
        disableForReducedMotion: true,
        colors: allProjectColors,
        zIndex: 10000,
    };

    function randomInRange(min, max) {
        return Math.random() * (max - min) + min;
    }

    const interval = setInterval(function () {
        const timeLeft = animationEnd - Date.now();

        if (timeLeft <= 0) {
            return clearInterval(interval);
        }

        const particleCount = 50 * (timeLeft / duration);
        // since particles fall down, start a bit higher than random
        confetti(
            Object.assign({}, defaults, {
                particleCount: particleCount,
                origin: { x: randomInRange(0.1, 0.4), y: Math.random() - 0.2 },
            })
        );
        confetti(
            Object.assign({}, defaults, {
                particleCount: particleCount,
                origin: { x: randomInRange(0.6, 0.9), y: Math.random() - 0.2 },
            })
        );
    }, 250);
}

function launchLesserConfetti() {
    const count = 200;
    const defaults = {
        angle: 270,
        scalar: 0.6,
        disableForReducedMotion: true,
        colors: confettiColors,
        zIndex: 10000,
        origin: { y: -0.1 },
    };

    function fire(particleRatio, opts) {
        confetti(
            Object.assign({}, defaults, opts, {
                particleCount: Math.floor(count * particleRatio),
            })
        );
    }

    fire(0.25, {
        spread: 26,
        startVelocity: 55,
    });
    fire(0.2, {
        spread: 60,
    });
    fire(0.35, {
        spread: 100,
        decay: 0.91,
        scalar: 0.8,
    });
    fire(0.1, {
        spread: 120,
        startVelocity: 25,
        decay: 0.92,
        scalar: 1.2,
    });
    fire(0.1, {
        spread: 120,
        startVelocity: 45,
    });
}

export { launchConfetti };
export { launchConfettiFireworks };
export { launchLesserConfetti };
